import {
  ExtractFnReturnType,
  QueryConfigType,
  useQuery,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersEmployeeConditionSubmissionsSubmissionRepliesIndexResponseType } from "~/domains";

type RequestDataType = {
  employeeConditionSubmissionId: string;
  page?: number;
};

const request = async ({
  employeeConditionSubmissionId,
  page = 1,
}: RequestDataType): Promise<ApiMembersEmployeeConditionSubmissionsSubmissionRepliesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersEmployeeConditionSubmissionsSubmissionRepliesIndexResponseType>(
      `/api/members/employee_condition_submissions/${employeeConditionSubmissionId}/submission_replies`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  employeeConditionSubmissionId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApiMembersEmployeeConditionSubmissionsSubmissionRepliesIndex =
  ({
    employeeConditionSubmissionId,
    config = {},
  }: PropsType): UseQueryResult<ApiMembersEmployeeConditionSubmissionsSubmissionRepliesIndexResponseType> => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
      ...config,
      queryKey: [
        "apiMembersEmployeeConditionSubmissionsSubmissionRepliesIndex",
        employeeConditionSubmissionId,
      ],
      queryFn: () => request({ employeeConditionSubmissionId }),
    });
  };
